import React from "react";
import '../Styles/Sass/Listings/listing.sass';

function ListingItem(props) {

  return (
    <div className="listingContainer" onClick={props.onClick}>
      <h2 className="listingName">{props.postedByName}</h2>
      <h3 className="listingJobTitle">{props.headline}</h3>
      <p className="listingJobDesc">{props.description}</p>
      <div className='listingSubBox'>
        <h5 className="listingCost">${props.rate} per Hour</h5>
        <h5 className="listingSFL">{props.city} | {props.postal} | {props.province}</h5>
      </div>
    </div>
  );
}

export default ListingItem;